var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 100 100",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m96.9872742 77.3538132c-4.3965149-9.1927109-11.8905792-15.1879692-22.6820221-17.8858299-1.598732-.3996849-3.2973862 0-4.5963516 1.0991287l-8.8929558 7.2942238c-1.698658 1.3988876-4.1966782 1.598732-6.0951691.3996811-9.3925591-5.7954063-17.0864601-13.4893112-22.8818684-22.8818703-1.1990509-1.8984947-.9992085-4.3965149.399683-6.0951653l7.29422-8.8929539c1.0991249-1.2989693 1.4988098-2.9976254 1.0991249-4.5963573-2.7977829-10.8913736-8.7930336-18.3854346-17.9857483-22.7819509-1.4988117-.6994457-3.1974659-.6994457-4.6962776.0999207-4.5963573 2.4980206-9.0927944 5.2958035-13.2894688 8.3933487-1.5987324 1.1990504-2.3980994 3.1974664-2.0983367 5.1958833 2.9976244 17.8858242 12.6899433 36.6709442 28.3775139 52.3585129s34.472683 25.2799683 52.3585091 28.3775177c1.9984207.2997665 3.9968338-.4996033 5.1958771-2.0983353 3.0975494-4.1966705 5.8953323-8.5931931 8.3933563-13.2894745.7993617-1.4988155.7993617-3.1974697.0999141-4.6962795z",
    fill: "rgb(0,0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.460a20f7c610374240022797c073c449.svg";
export { ForwardRef as ReactComponent };